import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import MiFileUpload from '@/components/mi-file-upload/MiFileUpload';
import { addClass, removeClass } from '@/support/Html';
import {Order} from "@/models/Order";
import {axiosDownload} from "@/support/Client";
import {PurchaseOrder} from "@/models/PurchaseOrder";

@Component<UploadOrderItemsCsvDialog>({})
export default class UploadOrderItemsCsvDialog extends Vue {
  @Prop()
  protected order!: Order;

  protected isLoading: boolean = false;
  protected activeStepper: boolean = true;
  protected currentStep: number = 1;

  protected isUploadingCsv: boolean = false;
  protected selectedCsvFile: File | null = null;
  protected uploadResponse: object | null = null;

  protected acceptedFileTypes = [
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ];
  protected uploadedFile: string = '';

  public mounted(): void {
    const pageHtml = document.querySelectorAll('html')[0];
    addClass(pageHtml, 'overflow-y-hidden');
  }

  protected goToStep(step: number) {
    if (this.currentStep < step || !this.activeStepper) {
      return;
    }

    this.currentStep = step;
  }

  protected close() {
    this.$emit('input', false);
    this.currentStep = 1;
    this.clear();
    const pageHtml = document.querySelectorAll('html')[0];
    removeClass(pageHtml, 'overflow-y-hidden');
  }

  protected clear() {
    this.selectedCsvFile = null;
  }

  protected handleItemDropped(file: File) {
    if(!file) {
      return;
    }

    this.selectedCsvFile = file;
    const fileUploadComponent = this.$refs.fileUpload as MiFileUpload;
    fileUploadComponent.uploaded();
  }

  protected async downloadTemplateCsv(): Promise<void> {
    try {
      await axiosDownload(
        {
          url: new Order().export(this.order && this.order.id ? this.order.id : ''),
          accept: 'text/csv; charset=utf-8'
        },
        {}
      );
    } catch (error) {
      ErrorHandler.network(error);
    }
  }

  protected create() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.currentStep = 2;

    const payload: Partial<Order> = {
      file: this.selectedCsvFile ? this.selectedCsvFile : undefined,
    };

    new Order()
      .import(this.order && this.order.id ? this.order.id : '')
      .create(payload)
      .then((response: AxiosResponse) => {
        this.isLoading = false;
        if (response) {
          this.uploadResponse = response;
        }
        this.$emit('uploaded');
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        this.isLoading = false;
        this.currentStep = 1;
      })
  }
}
